import frontendPackage from '../package.json'

export const FRONTEND_VERSION = frontendPackage.version
